var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.onClick || undefined}}},[_c('i',{staticClass:"material-icons"},[_vm._v("keyboard_arrow_right")])])}
var staticRenderFns = []

export { render, staticRenderFns }